import React, { ReactElement } from 'react';
import { useWalletContext } from 'hooks/wallet';
import { useAppContext } from 'hooks/useAppContext';
import {
  PurchaseObscuraMintPass2,
  PurchaseObscuraMintPass3,
  PurchaseSeasonPass,
} from 'hooks/purchaseSeasonPass';
import { COMMISSIONS } from 'logic/commissions';
import { Button } from './Button';
import { mintNFTCommunity } from 'logic/NFT';

export function ConnectWallet(): ReactElement {
  const { connectWallet, isConnected } = useWalletContext();
  const isDisabled = isConnected ? ' opacity-50' : '';
  return (
    <div className="flex justify-center sm:justify-start mt-10">
      <button
        className={
          'text-center sm:text-left bg-gray-100 px-4 rounded whitespace-nowrap h-10' +
          isDisabled
        }
        onClick={connectWallet}
      >
        <h3 className="text-black font-medium">Connect Wallet</h3>
      </button>
    </div>
  );
}

export function BuyPass({
  text: text,
  pass: pass,
  numberOfPasses,
}): ReactElement {
  const { isConnected } = useWalletContext();
  return (
    <Button
      backgroundColor="bg-gray-100"
      disabled={!isConnected}
      onClick={() => {
        PurchaseSeasonPass({ pass: pass, numberOfPasses: numberOfPasses });
      }}
    >
      <h3 className="text-black font-medium">{text}</h3>
    </Button>
  );
}

export function BuyObscuraMintPass2({
  text,
  passId,
  textStyle,
  buttonStyle,
  buttonColor,
}: {
  text: string;
  passId: string | number;
  textStyle?: string;
  buttonStyle?: string;
  buttonColor?: string;
}): ReactElement {
  const { isConnected } = useWalletContext();
  const { setTxState } = useAppContext();
  const isDisabled = isConnected ? '' : ' opacity-70';

  return (
    <button
      className={
        'text-center sm:text-left px-4 rounded whitespace-nowrap h-10' +
        isDisabled +
        ' ' +
        buttonStyle +
        ` ${buttonColor ? buttonColor : 'bg-gray-100'}`
      }
      onClick={() => {
        PurchaseObscuraMintPass2(passId, setTxState);
      }}
    >
      <h3 className={`text-black ${textStyle ? textStyle : 'font-medium'}`}>
        {text}
      </h3>
    </button>
  );
}

export function BuyObscuraMintPass3({
  text,
  tier,
  textStyle,
  buttonStyle,
  buttonColor,
}: {
  text: string;
  tier: COMMISSIONS;
  textStyle?: string;
  buttonStyle?: string;
  buttonColor?: string;
}): ReactElement {
  const { isConnected } = useWalletContext();
  const { setTxState } = useAppContext();
  const isDisabled = isConnected ? '' : ' opacity-70';

  return (
    <button
      className={
        'font-semibold text-center sm:text-left px-4 rounded whitespace-nowrap h-10' +
        isDisabled +
        ' ' +
        buttonStyle +
        ` ${buttonColor ? buttonColor : 'bg-gray-100'}`
      }
      onClick={() => {
        PurchaseObscuraMintPass3(tier, setTxState);
      }}
    >
      <h3 className={`text-black ${textStyle ? textStyle : 'font-medium'}`}>
        {text}
      </h3>
    </button>
  );
}


export function CommissionTierBuyButton({
  commissionSlug,
  backgroundColor,
  textColor,
}: {
  commissionSlug: string;
  backgroundColor?: string;
  textColor?: string;
}) {
  const buttonProps = {
    backgroundColor,
    color: textColor,
  };
  // todo: how to toggle sold out or not
  switch (commissionSlug) {
    case COMMISSIONS.community:
      return (
        <Button {...buttonProps}>
          <a
            href="https://marketplace.obscura.io/collections/0xd705b41d5d5fff1b688bd5d7dd5baf52d50b7269"
            className="self-center"
            target="_blank"
            rel="noreferrer"
          >
            Obscura Community Photos on Secondary
          </a>
        </Button>
      );
    case COMMISSIONS.curated:
      return (
        <Button {...buttonProps}>
          <a
            href="https://opensea.io/collection/obscura-mint-pass?search[sortBy]=PRICE&search[sortAscending]=true&search[toggles][0]=BUY_NOW"
            className="self-center"
            target="_blank"
            rel="noreferrer"
          >
            Buy Curated Pass
          </a>
        </Button>
      );
    case COMMISSIONS.foundry:
      return (
        <Button {...buttonProps}>
          <a
            href="https://marketplace.obscura.io/collections/0x4f47eb80e0c6b47766fae58be5fbeafe9505e134"
            className="self-center"
            target="_blank"
            rel="noreferrer"
          >
            Obscura Foundry Photos on Secondary
          </a>
        </Button>
      );
    case COMMISSIONS.magnum:
      return (
        <Button {...buttonProps}>
          <a
            href="https://opensea.io/collection/obscura-mint-pass?search[sortBy]=PRICE&search[sortAscending]=true&search[toggles][0]=BUY_NOW"
            className="self-center"
            target="_blank"
            rel="noreferrer"
          >
            Buy Magnum Pass
          </a>
        </Button>
      );
    default:
      return null;
  }
}

CommissionTierBuyButton.defaultProps = {
  backgroundColor: 'bg-white',
  textColor: 'text-white',
};

export function MintCommunityButton({
  text,
  passId,
}: {
  text: string;
  passId: string | number;
}): ReactElement {
  const { isConnected } = useWalletContext();
  const { setTxState } = useAppContext();
  const isDisabled = isConnected ? "" : " opacity-70";

  return (
    <div className="my-4 mt-9 hover:opacity-70 cursor-pointer h-14">
      <a
        onClick={() => mintNFTCommunity(passId, setTxState)}
        className={`font-medium text-2xl border-solid border-2 border-black px-7 py-3 ${isDisabled}`}
      >
        {text}
      </a>
    </div>
  );
}
